// @flow
import React, { useState } from 'react';

import { StyledTab } from '../../common-utils/styledComponents';

export const TabsContainer = ({ tabPanes, callbackOnTabChange = null, initialActiveIndex = 0 }) => {
  const [activeTabIndex, setActiveTabIndex] = useState(initialActiveIndex);

  const handleTabChange = async (e, { activeIndex }) => {
    if (callbackOnTabChange) {
      await callbackOnTabChange(activeIndex);
    }
    setActiveTabIndex(activeIndex);
  };

  return (
    <StyledTab
      activeIndex={activeTabIndex}
      menu={{ secondary: true, pointing: true }}
      onTabChange={handleTabChange}
      panes={tabPanes}
    />
  );
};
